import { render, staticRenderFns } from "./technician-dashboard.vue?vue&type=template&id=f3ce3748&scoped=true"
import script from "./technician-dashboard.vue?vue&type=script&lang=ts"
export * from "./technician-dashboard.vue?vue&type=script&lang=ts"
import style0 from "./technician-dashboard.vue?vue&type=style&index=0&id=f3ce3748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ce3748",
  null
  
)

export default component.exports